export default "__VITE_ASSET__BndZBzkY__"